import React from 'react';
import PropTypes from 'prop-types';
import FormattedListValue from '@/shared/components/FormattedListValue';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../jobMessages';
import utils from '@/shared/utils/adminpulse';
import Checkbox from '@/shared/components/input/Checkbox';

const JobDetailDeleteTaskSchedule = ({ job }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);

  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.TaskTemplate} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue
                  list="tasktemplate"
                  id={parameters.taskTemplateId}
                  fallback=""
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Schedule} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue
                  list="taskperiodicity"
                  id={parameters.periodicityId}
                  fallback=""
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.DeletePlannedTasks} />
                  </b>
                </label>
              </div>
              <div className="col-md-5 col-sm-6">
                <Checkbox value={parameters.deletePlannedTasks} onClick={() => {}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailDeleteTaskSchedule.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailDeleteTaskSchedule);
